import { Component, input, Optional, output, Signal, SkipSelf } from '@angular/core';

/**
 * services
 */
import { TableStateService } from '../../services';

/**
 * directives
 */
import { FormCheckFieldDirective } from '@forms/directives/form-check-field/form-check-field.directive';

@Component({
  selector: 'app-table-header-checkbox',
  templateUrl: './table-header-checkbox.component.html',
  styleUrl: './table-header-checkbox.component.scss',
  imports: [
    FormCheckFieldDirective,
  ],
})
export class TableHeaderCheckboxComponent {

  /**
   * @description Name of the checkbox
   */
  public name = input.required<string, string>({
    transform: (value: string) => value ? `table_row_select_${value}` : ''
  });

  /**
   * @description Id of the checkbox
   */
  public id = input.required<string, string>({
    transform: (value: string) => value ? `table_row_select_${value}` : ''
  });

  /**
   * @description Output event when the checkbox is changed
   */
  public onChange = output<unknown>();
  
  /**
   * @description Frazzled state of the checkbox
   */
  public get frazzled(): Signal<boolean> {
    return this.tableState.frazzled;
  }

  /**
   *
   */
  constructor(
    @Optional()
    @SkipSelf()
    public readonly tableState: TableStateService
  ) {}
  
  /**
   * Method to check if all current page rows are selected
   */
  public checked(): boolean {
    return this.tableState.isAllCurrentPageRowsSelected();
  }

  /**
   * Method to check if any current page rows are selected
   */
  public indeterminate(): boolean {
    return !this.checked() && this.tableState.isAnyCurrentPageRowsSelected();
  }
  
  /**
   * Method to handle the change event of the checkbox
   * @param event 
   */
  public onChangeHandler(event: unknown): void {

    const isSelected = event as boolean;
    this.tableState.onToggleAllRows(this.tableState.paginatedData(), isSelected);
    
    this.onChange.emit(isSelected);

  }

}
